import { Terminology, TerminologyOptions } from "@/types/v2";
import { createContext } from "react";

export const defaultTerminology: Terminology = {
  [TerminologyOptions.repairOrderNumber]: {
    singular: "Repair Order Number",
    plural: "Repair Order Numbers",
    acronym: "RO Number",
  },
  [TerminologyOptions.repairOrder]: {
    singular: "Repair Order",
    plural: "Repair Orders",
    acronym: "RO",
  },
  [TerminologyOptions.serviceAdvisor]: {
    singular: "Service Advisor",
    plural: "Service Advisors",
    acronym: "SA",
  },
  [TerminologyOptions.technician]: {
    singular: "Technician",
    plural: "Technicians",
    acronym: "TECH",
  },
  [TerminologyOptions.vehicle]: {
    singular: "Vehicle",
    plural: "Vehicles",
    acronym: "VEH",
  },
};

export const TerminologyContext = createContext<{
  terminology: Terminology;
  setTerminology: (terminology: Terminology) => void;
}>({
  terminology: defaultTerminology,
  setTerminology: () => {},
});
